import { ArticleType, ArticleResolution } from '@wix/answers-api';
import { Badge, Box } from '@wix/design-system';
import React from 'react';
import { CategoryTag } from './CategoryTag';
import { CommentsAndWatch } from './CommentsAndWatch';
import { ETATag } from './ETATag';
import { ReadingTime } from './ReadingTime';
import { StatusTag } from './StatusTag';
import { ArticleSearchResultDocumentType } from '../../../types';
import { DATA_HOOKS } from '../../../dataHooks';
import { sanitizeHtml } from '../../../utils/text';
var CATEGORY_TAGS_ARTICLES = [ArticleType.ARTICLE, ArticleType.FEATURE_REQUEST];
var ETA_TAGS_RESOLUTIONS = [ArticleResolution.PLANNED, ArticleResolution.IN_DEVELOPMENT];
export var Tags = function (_a) {
    var type = _a.type, resolution = _a.resolution, resolutionEta = _a.resolutionEta, onCategoryClick = _a.onCategoryClick, rootTopic = _a.rootTopic, readingTimeInMinutes = _a.readingTimeInMinutes, isMobileView = _a.isMobileView, docType = _a.docType, views = _a.views, replies = _a.replies, topic = _a.topic, innerLinkComponent = _a.innerLinkComponent;
    var showStatusTag = type === ArticleType.FEATURE_REQUEST ||
        type === ArticleType.KNOWN_ISSUE ||
        docType === ArticleSearchResultDocumentType.WIX_FORUM_TOPIC;
    var showEtaTag = type === ArticleType.FEATURE_REQUEST && resolution && ETA_TAGS_RESOLUTIONS.includes(resolution);
    var showCategoryTag = type && CATEGORY_TAGS_ARTICLES.includes(type);
    var showReadingTime = readingTimeInMinutes && isMobileView;
    var wixStudioAcademy = docType === ArticleSearchResultDocumentType.WIX_STUDIO_ACADEMY;
    return (React.createElement(Box, { dataHook: DATA_HOOKS.SEARCH_RESULT_ITEM_BADGES, marginTop: "SP2", gap: '9px', justifyItems: "center", flexWrap: "wrap", align: "center" },
        showStatusTag && (React.createElement(StatusTag, { status: resolution, type: type, resolutionEta: resolutionEta, docType: docType })),
        showEtaTag && React.createElement(ETATag, { eta: resolutionEta }),
        showCategoryTag && React.createElement(CategoryTag, { innerLinkComponent: innerLinkComponent, onClick: onCategoryClick, category: rootTopic }),
        docType ===
            ArticleSearchResultDocumentType.WIX_FORUM_TOPIC && (React.createElement(CommentsAndWatch, { watchCount: views, commentsCount: replies })),
        wixStudioAcademy && topic && React.createElement(Badge, { type: "outlined", skin: 'neutralLight', size: "tiny" }, sanitizeHtml(topic)),
        showReadingTime &&
            type !== ArticleType.FEATURE_REQUEST &&
            type !== ArticleType.KNOWN_ISSUE && (React.createElement(ReadingTime, { readingTimeInMinutes: readingTimeInMinutes }))));
};
//# sourceMappingURL=index.js.map